/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUnclaimedSupplyResponse
 */
export interface GetUnclaimedSupplyResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUnclaimedSupplyResponse
     */
    amount: number;
}

export function GetUnclaimedSupplyResponseFromJSON(json: any): GetUnclaimedSupplyResponse {
    return GetUnclaimedSupplyResponseFromJSONTyped(json, false);
}

export function GetUnclaimedSupplyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnclaimedSupplyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function GetUnclaimedSupplyResponseToJSON(value?: GetUnclaimedSupplyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
    };
}


